import Stack from "@mui/material/Stack";

interface PageLayout {
  children: React.ReactNode;
}

export const PageLayout = ({ children }: PageLayout) => {
  return <Stack gap="24px">{children}</Stack>;
};
